import { render, staticRenderFns } from "./SliderFilter.vue?vue&type=template&id=a6874834&"
import script from "./SliderFilter.vue?vue&type=script&lang=js&"
export * from "./SliderFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports